import { Waiter } from "./promises";
export async function onVideoTime({ videoElement, timeMillis, callback, }) {
    const waiter = new Waiter();
    const endWaiter = new Waiter();
    const onTimeUpdate = () => {
        waiter.trigger();
    };
    const onEnded = () => {
        endWaiter.trigger();
    };
    videoElement.addEventListener("timeupdate", onTimeUpdate);
    videoElement.addEventListener("ended", onEnded);
    while (true) {
        await Promise.race([waiter.wait(), endWaiter.wait()]);
        endWaiter.clear();
        waiter.reset();
        if (endWaiter.triggered) {
            break;
        }
        if (videoElement.currentTime * 1000 >= timeMillis) {
            break;
        }
    }
    videoElement.removeEventListener("timeupdate", onTimeUpdate);
    videoElement.removeEventListener("ended", onEnded);
    callback();
}
//# sourceMappingURL=video.js.map